import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Bonus, CachedBonus, CachedBonuses } from '../../../../../../types/bonus';
import { CachedProfileBonuses, updateCachedReactions, updateCachedReactionsInProfile, updateSingleBonusReactions } from '../../../cache/mutators/bonus';
import { QueryKey } from '../../../hooks/types';

export const useReplaceBonus = () => {
	const queryClient = useQueryClient();

	return useCallback(
		(newBonus: Bonus) => {
			queryClient.setQueriesData<CachedBonuses>([QueryKey.BonusesInfinite], (cached) => updateCachedReactions(newBonus.id, newBonus.reactions ?? [], cached));
			queryClient.setQueryData<CachedBonus>([QueryKey.Bonus, newBonus.id], (cached) =>
				updateSingleBonusReactions(newBonus.id, newBonus.reactions ?? [], cached)
			);
			queryClient.setQueriesData<CachedProfileBonuses>([QueryKey.ProfileBonuses], (cached) =>
				updateCachedReactionsInProfile(newBonus.id, newBonus.reactions ?? [], cached)
			);

			if (newBonus.parent_bonus_id) {
				queryClient.setQueryData<CachedBonus>([QueryKey.Bonus, newBonus.parent_bonus_id], (cached) =>
					updateSingleBonusReactions(newBonus.id, newBonus.reactions ?? [], cached)
				);
			}
		},
		[queryClient]
	);
};
